export const convertOptionsToMap = <T = string>(
  options: OptionType<T>[]
  // @ts-ignore
): Record<T, OptionType['label']> => {
  return Object.fromEntries(options.map(o => [o.value, o.label])) as Record<
    // @ts-ignore
    T,
    OptionType['label']
  >;
};
